export default __webpack_public_path__ + "static/media/html2.e6f2814b.svg";